import React, { useState } from 'react';
import { useSurvey } from '../../../context/SurveyContext';
import { Save, Send, Link, Check, X } from 'lucide-react';

const TopBar = () => {
  const { currentSurvey, updateSurveySettings, publishSurvey, closeSurvey } = useSurvey();
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleTitleChange = (e) => {
    updateSurveySettings({ title: e.target.value });
  };

  const handlePublish = () => {
    publishSurvey();
    setShowPublishModal(true);
  };

  const getSurveyUrl = () => {
    const baseUrl = window.location.origin;
    return `${baseUrl}/survey/${currentSurvey?.id}`;
  };

  const copyLink = () => {
    navigator.clipboard.writeText(getSurveyUrl());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="top-bar">
      <input
        type="text"
        className="survey-title-input"
        value={currentSurvey?.title || ''}
        onChange={handleTitleChange}
        placeholder="Survey Title"
      />
      
      <div className="top-bar-actions">
        {currentSurvey?.status === 'live' && (
          <div className="survey-live-badge">
            <span className="live-dot"></span>
            Live
          </div>
        )}
        
        {currentSurvey?.status !== 'live' ? (
          <button 
            className="btn-publish"
            onClick={handlePublish}
            disabled={!currentSurvey?.questions?.length}
          >
            <Send size={16} />
            Publish Survey
          </button>
        ) : (
          <>
            <button className="btn-secondary" onClick={() => setShowPublishModal(true)}>
              <Link size={16} />
              Get Link
            </button>
            <button 
              className="btn-secondary"
              onClick={closeSurvey}
              style={{ color: '#dc2626' }}
            >
              Close Survey
            </button>
          </>
        )}
      </div>

      {showPublishModal && (
        <div className="publish-modal-overlay" onClick={() => setShowPublishModal(false)}>
          <div className="publish-modal" onClick={e => e.stopPropagation()}>
            <div className="publish-modal-header">
              <h3>Survey Published!</h3>
              <button className="modal-close" onClick={() => setShowPublishModal(false)}>
                <X size={20} />
              </button>
            </div>
            <div className="publish-modal-content">
              <p>Share this link with your respondents:</p>
              <div className="link-box">
                <input 
                  type="text" 
                  value={getSurveyUrl()} 
                  readOnly 
                  className="link-input"
                />
                <button className="copy-btn" onClick={copyLink}>
                  {copied ? <Check size={18} /> : <Link size={18} />}
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
              <p className="note">
                Note: For this demo, responses are stored in your browser's local storage.
                In a production environment, you would share an actual URL.
              </p>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .survey-live-badge {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          background: #dcfce7;
          color: #166534;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 500;
        }
        .live-dot {
          width: 8px;
          height: 8px;
          background: #22c55e;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        .publish-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .publish-modal {
          background: white;
          border-radius: 16px;
          width: 90%;
          max-width: 500px;
          overflow: hidden;
        }
        .publish-modal-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 20px;
          border-bottom: 1px solid #e2e8f0;
        }
        .publish-modal-header h3 {
          margin: 0;
          font-size: 18px;
          color: #1e293b;
        }
        .modal-close {
          padding: 4px;
          background: transparent;
          border: none;
          color: #64748b;
          cursor: pointer;
          border-radius: 6px;
        }
        .modal-close:hover {
          background: #f1f5f9;
        }
        .publish-modal-content {
          padding: 20px;
        }
        .publish-modal-content p {
          margin: 0 0 12px;
          color: #475569;
        }
        .link-box {
          display: flex;
          gap: 8px;
          margin-bottom: 16px;
        }
        .link-input {
          flex: 1;
          padding: 10px 14px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 13px;
          background: #f8fafc;
          color: #1e293b;
        }
        .copy-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          background: #6366f1;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          cursor: pointer;
        }
        .copy-btn:hover {
          background: #4f46e5;
        }
        .note {
          font-size: 12px;
          color: #94a3b8;
          background: #f8fafc;
          padding: 12px;
          border-radius: 8px;
          margin-top: 16px;
        }
      `}</style>
    </div>
  );
};

export default TopBar;
